import axios from 'axios';
import * as React from 'react';

interface ITitleState {
    version : string
}

export default class Title extends React.Component<{}, ITitleState> {

    constructor(props: any) {
        super(props);
        this.state = {version : ""};
    }

    public componentDidMount() {
        this.fetchVersion().then((result) => {
            this.setState({version : result.version});
        });
    }

    public render() {
        return <h2>Web Editor v{this.state.version}</h2>

    }

    private fetchVersion = async () => {
        try {
            const response = await axios.get("./version", {timeout : 3000});
            if (response.status === 200) 
                return {
                    version: response.data,
                    status: 200
                }
        } catch ({response}) {
            console.log("Failed to load version number: ", response);
            return {
                version: "0.0",
                status: 404
            }
        }
        console.log("Failed to load version number");
        return {
            version: "0.0",
            status: 500
        };
    }
}


// WEBPACK FOOTER //
// ./src/App/Title.tsx